const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-800 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-6">
          <p className="text-gray-400 text-sm font-light">
            &copy; {currentYear} Nadishan Danthanarayana. All rights reserved.
          </p>
          <div className="flex justify-center gap-8">
            <button
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector('#home')
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-gray-400 hover:text-white transition-colors duration-300 text-sm font-light"
            >
              Home
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector('#about')
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-gray-400 hover:text-white transition-colors duration-300 text-sm font-light"
            >
              About
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector('#projects')
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-gray-400 hover:text-white transition-colors duration-300 text-sm font-light"
            >
              Projects
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector('#contact')
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-gray-400 hover:text-white transition-colors duration-300 text-sm font-light"
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;